module.exports = __webpack_public_path__ + "static/media/reddit_border.7c389c5f.png";